import { Typography, VopStatus } from '@dxb-web-ui-framework/design-system';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export enum VopStatusEnum {
  EXACT_MATCH = 'EXACT_MATCH',
  CLOSE_MATCH = 'CLOSE_MATCH',
  NO_MATCH = 'NO_MATCH',
  NOT_COMPLETED = 'NOT_COMPLETED',
}

interface VopStatusWrapperProps {
  vopStatus: VopStatusEnum;
  onClick?: () => void;
  isTable?: boolean;
}

const VopStatusWrapper: FC<VopStatusWrapperProps> = ({ onClick, vopStatus, isTable }) => {
  const { t } = useTranslation();
  if (vopStatus === undefined || vopStatus === null)
    return (
      <Typography variant='subtitle1' color='textSecondary' style={{ paddingLeft: 32 }}>
        {t('fundsTransferPage.TransferStepper.TransferConfirm.Vop.InternalTransfer.Title')}
      </Typography>
    );

  const vopStatusInfo = {
    [VopStatusEnum.EXACT_MATCH]: {
      title: t('fundsTransferPage.TransferStepper.TransferConfirm.Vop.ExactMatch.Title'),
      description: t('fundsTransferPage.TransferStepper.TransferConfirm.Vop.ExactMatch.Text'),
      onClick: undefined,
    },
    [VopStatusEnum.CLOSE_MATCH]: {
      title: t('fundsTransferPage.TransferStepper.TransferConfirm.Vop.CloseMatch.Title'),
      description: t('fundsTransferPage.TransferStepper.TransferConfirm.Vop.CloseMatch.Text'),
      onClick: undefined,
    },
    [VopStatusEnum.NO_MATCH]: {
      title: t('fundsTransferPage.TransferStepper.TransferConfirm.Vop.NoMatch.Title'),
      description: t('fundsTransferPage.TransferStepper.TransferConfirm.Vop.NoMatch.Text'),
      onClick: undefined,
    },
    [VopStatusEnum.NOT_COMPLETED]: {
      title: t('fundsTransferPage.TransferStepper.TransferConfirm.Vop.NotCompleted.Title'),
      description: t('fundsTransferPage.TransferStepper.TransferConfirm.Vop.NotCompleted.Text'),
      onClick,
    },
  };
  return (
    <VopStatus
      title={vopStatusInfo[vopStatus].title}
      variant={vopStatus}
      helperTitle={t('fundsTransferPage.TransferStepper.TransferConfirm.Vop.HelperText.Text')}
      description={vopStatusInfo[vopStatus].description}
      onClick={vopStatusInfo[vopStatus]?.onClick}
      tooltip={t('fundsTransferPage.TransferStepper.TransferConfirm.Vop.ToolTip.Text')}
      isTable={isTable}
    />
  );
};

export { VopStatusWrapper };
export default VopStatusWrapper;
